// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resourceText input{font-size:.875rem;line-height:1.2!important;color:#000;color:rgba(0,0,0,.6)!important}.v-input__slot{padding-left:2px!important}.linkFavicon{margin-top:2px}", ""]);
// Exports
module.exports = exports;
